<script>
    import {API_URL} from "../../../env";
    import AccountHeader from "../../components/account/AccountHeader.svelte";
    import AccountNav from "../../components/account/AccountNav.svelte";
    import Loading from "../../placeholders/ContentLoading.svelte";
    import Error from "../../placeholders/Error.svelte";
    import getFormattedDate from "../../lib/getFormattedDate";
    import getFormattedPriceFromOrder from "../../lib/getFormattedPriceFromOrder";
    import checkLoginValidity from "../../lib/checkLoginValidity";
    import {push, replace} from "svelte-spa-router";
    import {userData} from "../../js/stores";

    window.scrollTo(0, 0);
    if ($userData === null) replace("/?m=prihlasit-sa")

    let data = fetchData()

    async function fetchData() {
        const res = await fetch(API_URL + '/users/orders', {
            method: 'GET',
            credentials: "include",
        })

        if (checkLoginValidity(res.status)) {return await push("/");}
        const data = await res.json()

        for (let order of data) {
            order.manufacturers = order.products.filter((value, index, self) =>
                index === self.findIndex((t) => (
                    t.manufacturer === value.manufacturer
                ))
            )
        }
        return data
    }
</script>

<section class="container" id="account">
    <AccountHeader />

    <div class="account">
        <AccountNav />

        <div class="account-content">
            <h2>MOJE OBJEDNÁVKY</h2>
            <p>V zozname objednávok môžete sledovať ako aktívne objednávky, tak detaily tých, ktoré už v minulosti prebehli. Keď ktorúkoľvek z nich rozkliknete, uvidíte všetky dôležité podrobnosti, ktoré vám prídu vhod.</p>
            <div class="ord-list">
                {#await data}
                    <Loading/>
                {:then data}
                    {#if data?.length > 0}
                        {#each data as order}
                            <a href="#/ucet/detail-objednavky/{order.id}" class="ord-item">
                                <div class="ord-image">
                                    <img src={order.products[0]?.product_picture || "assets/img/nahled.webp"} alt="">
                                </div>
                                <div class="ord-info">
                                    <h4>Objednávka #{order.id}</h4>
                                    <ul>
                                        <li><p>Počet položek</p><p>{order.products.reduce((a, v) => { return a + v.product_quantity }, 0)}ks</p></li>
                                        <li><p>Objednané</p><p>{getFormattedDate(order.created)}</p></li>
                                        <li><p>Cena</p><p>{getFormattedPriceFromOrder(order)}€</p></li>
                                        <li><p>Status</p>
                                            {#if order.tags.length > 0}
                                                <p style="color: black"><i class="far fa-fw fa-{order.tags[0].icon || 'check-circle'}"></i> {order.tags[0].name || ''}</p>
                                            {:else}
                                                <p style="color: black"><i class="far fa-fw fa-check-circle"></i> Prijaté</p>
                                            {/if}
                                        </li>
                                    </ul>
                                </div>
                                <div class="ord-brands">
                                    <div class="ord-brand">
                                        {#if order.manufacturers[0]?.manufacturer_logo}
                                            <img src={order.manufacturers[0]?.manufacturer_logo} alt={order.manufacturers[0]?.manufacturer}>
                                        {:else}
                                            <p><b>{order.manufacturers[0]?.manufacturer || ""}</b></p>
                                        {/if}
                                    </div>
                                    {#if order.manufacturers.length >= 2}
                                        <div class="ord-brand">
                                            {#if order.manufacturers[1].manufacturer_logo}
                                                <img src={order.manufacturers[1]?.manufacturer_logo} alt={order.manufacturers[1]?.manufacturer}>
                                            {:else}
                                                <p><b>{order.manufacturers[1]?.manufacturer || ""}</b></p>
                                            {/if}
                                        </div>
                                    {/if}
                                    {#if order.manufacturers.length === 3}
                                        <div class="ord-brand">
                                            {#if order.manufacturers[2].manufacturer_logo}
                                                <img src={order.manufacturers[2]?.manufacturer_logo} alt={order.manufacturers[2]?.manufacturer}>
                                            {:else}
                                                <p><b>{order.manufacturers[2]?.manufacturer || ""}</b></p>
                                            {/if}
                                        </div>
                                    {:else if order.manufacturers.length > 3}
                                        <div class="ord-brand">
                                            <p>a ďalšie...</p>
                                        </div>
                                    {/if}
                                </div>
                                <div class="ord-button">
                                    <a href="#/ucet/detail-objednavky/{order.id}"><span>Detail objednávky</span> <i class="fas fa-fw fa-arrow-right ml-2"></i></a>
                                </div>
                            </a>
                        {/each}
                    {:else}
                        <p>Zatiaľ ste neurobili žiadnu objednávku. Vyberte si z <a href="#/">širokej ponuky pneumatík</a>.</p>
                    {/if}
                {:catch error}
                    <Error/>
                {/await}
            </div>
        </div>
    </div>
</section>


<style>
    .ord-list p a {
        color: unset;
        text-decoration: underline;
        transition: 0.1s linear;
    }
    .ord-list p a:hover {
        color: black;
    }
</style>